export interface FoundationMeeting {
  pastMeeting: Meeting[];
  upcoming: Meeting[];
}

export interface Meeting {
  name: string;
  date: Date;
}
